export default [
    { key: 'text/jinja2', label: 'Jinja2' },
    { key: 'text/markdown', label: 'Markdown' },
    { key: 'text/plain', label: 'Plaintext' },
]